// Statistics counters
document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.pages-statistics');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!sections.length || prefersReducedMotion) return;

    const formatNumber = (value) => {
        return Math.round(value)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };

    const animateNumber = (number, index) => {
        const target = parseFloat(number.dataset.value);
        const prefix = number.dataset.prefix || '';
        const suffix = number.dataset.suffix || '';
        const duration = 1200 + index * 140;
        const startTime = performance.now();

        if (!target) return;

        const update = (currentTime) => {
            const progress = Math.min((currentTime - startTime) / duration, 1);
            const easedProgress = 1 - Math.pow(1 - progress, 3);
            const currentValue = target * easedProgress;

            number.textContent = `${prefix}${formatNumber(currentValue)}${suffix}`;

            if (progress < 1) {
                requestAnimationFrame(update);
            } else {
                number.textContent = `${prefix}${formatNumber(target)}${suffix}`;
            }
        };

        number.textContent = `${prefix}0${suffix}`;
        requestAnimationFrame(update);
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const section = entry.target;
            const numbers = section.querySelectorAll('[data-statistics-number]');

            section.classList.add('is-statistics-active');
            numbers.forEach((number, index) => animateNumber(number, index));
            observer.unobserve(section);
        });
    }, {
        threshold: 0.35
    });

    sections.forEach(section => observer.observe(section));
});

// Locations map
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-locations-map]').forEach((section) => {
        const map = section.querySelector('[data-locations-map-graphic]');
        const svg = map?.querySelector('svg');
        const tooltip = section.querySelector('[data-locations-map-tooltip]');
        const tooltipFlag = section.querySelector('[data-locations-map-tooltip-flag]');
        const tooltipName = section.querySelector('[data-locations-map-tooltip-name]');
        const modal = section.querySelector('[data-locations-map-modal]');
        const modalContent = section.querySelector('[data-locations-map-modal-content]');
        const cards = Array.from(section.querySelectorAll('[data-locations-map-card]'));

        if (!map || !svg || !tooltip || !modal || !modalContent || !cards.length) return;

        const modalOpenClass = 'is-locations-map-modal-open';
        const modalSpacing = 24;
        const modalTooltipOffset = 34;
        const currentLanguageCode = (section.dataset.currentLanguage || '').toUpperCase();
        let activeCountryGroup = [];
        let activeShippingGroup = [];

        const groupedCountryShapes = {
            CZ: ['SK'],
        };

        const currentLanguageCountryMap = {
            PL: ['PL'],
            DE: ['DE'],
            FR: ['FR'],
            IT: ['IT'],
            CS: ['CZ'],
            SK: ['SK'],
            EN: ['GB', 'UK', 'EN'],
        };

        const countryCodeAliases = {
            PL: ['PL', 'POL'],
            DE: ['DE', 'DEU', 'GER', 'GERMANY', 'DEUTSCHLAND'],
            FR: ['FR', 'FRA', 'FRANCE'],
            IT: ['IT', 'ITA', 'ITALY', 'ITALIA'],
            CZ: ['CZ', 'CS', 'CZE', 'CZECHIA'],
            SK: ['SK', 'SVK', 'SLOVAKIA'],
            GB: ['GB', 'UK', 'EN', 'GBR', 'UNITEDKINGDOM'],
        };

        const aliasToCountryCode = Object.entries(countryCodeAliases).reduce((items, [countryCode, aliases]) => {
            aliases.forEach((alias) => {
                items[alias] = countryCode;
            });

            return items;
        }, {});

        const normalizeCountryCode = (value) => {
            const normalizedValue = String(value || '')
                .trim()
                .toUpperCase()
                .replace(/[^A-Z0-9]+/g, '-');

            if (!normalizedValue) return '';

            if (aliasToCountryCode[normalizedValue]) {
                return aliasToCountryCode[normalizedValue];
            }

            const tokens = normalizedValue.split('-').filter(Boolean);
            const matchedToken = tokens.find((token) => aliasToCountryCode[token]);

            if (matchedToken) {
                return aliasToCountryCode[matchedToken];
            }

            const matchedAlias = Object.keys(aliasToCountryCode).find((alias) => normalizedValue.includes(alias));

            if (matchedAlias) {
                return aliasToCountryCode[matchedAlias];
            }

            return normalizedValue;
        };

        const parseCountryCodes = (value) => {
            if (!value) return [];

            return value
                .split(/[,;\s]+/)
                .map(normalizeCountryCode)
                .filter(Boolean);
        };

        const countryItems = cards.reduce((items, card) => {
            const countryCode = normalizeCountryCode(card.dataset.country);

            if (countryCode) {
                items[countryCode] = card;
            }

            return items;
        }, {});

        const countryShapes = Array.from(svg.querySelectorAll('[id], [data-country]')).reduce((items, shape) => {
            const countryCode = normalizeCountryCode(shape.dataset.country || shape.id);

            if (!countryCode) return items;

            shape.classList.add('pages-locations-map__country-shape');
            shape.dataset.normalizedCountry = countryCode;
            items[countryCode] = items[countryCode] || [];
            items[countryCode].push(shape);

            return items;
        }, {});

        const getCountryShapes = (countryCode) => [
            ...(countryShapes[countryCode] || []),
            ...((groupedCountryShapes[countryCode] || []).flatMap((groupedCountryCode) => countryShapes[groupedCountryCode] || [])),
        ];

        const setShippingCountryState = (countries, isActive) => {
            countries.forEach((country) => {
                country.classList.toggle('is-shipping-hovered', isActive);
            });
        };

        const clearShippingCountryState = () => {
            setShippingCountryState(activeShippingGroup, false);
            activeShippingGroup = [];
        };

        svg.querySelectorAll('.pages-locations-map__point').forEach((point) => {
            point.setAttribute('aria-hidden', 'true');
        });

        const currentCountryOutline = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        currentCountryOutline.classList.add('pages-locations-map__current-country-outline');
        currentCountryOutline.setAttribute('aria-hidden', 'true');

        (currentLanguageCountryMap[currentLanguageCode] || []).forEach((countryCode) => {
            (countryShapes[countryCode] || []).forEach((country) => {
                const countryOutline = country.cloneNode(true);

                countryOutline.removeAttribute('id');
                countryOutline.removeAttribute('data-country');
                countryOutline.removeAttribute('tabindex');
                countryOutline.removeAttribute('role');
                countryOutline.removeAttribute('aria-label');
                countryOutline.classList.add('pages-locations-map__current-country-outline-shape');
                countryOutline.querySelectorAll('[id], [data-country]').forEach((element) => {
                    element.removeAttribute('id');
                    element.removeAttribute('data-country');
                });

                currentCountryOutline.appendChild(countryOutline);
            });
        });

        if (currentCountryOutline.children.length) {
            const firstPoint = svg.querySelector('.pages-locations-map__point');
            svg.insertBefore(currentCountryOutline, firstPoint || null);
        }

        const clamp = (value, min, max) => Math.min(Math.max(value, min), Math.max(min, max));

        const setModalPosition = (country) => {
            const dialog = modal.querySelector('.pages-locations-map__modal-dialog');
            const modalRect = modal.getBoundingClientRect();
            const countryRect = country.getBoundingClientRect();
            const tooltipRect = tooltip.getBoundingClientRect();
            const dialogWidth = dialog?.offsetWidth || 420;
            const dialogHeight = dialog?.offsetHeight || 240;
            const hasTooltipPosition = tooltip.classList.contains('is-visible') && tooltipRect.width && tooltipRect.height;
            const left = hasTooltipPosition
                ? tooltipRect.left + Math.min(modalTooltipOffset, tooltipRect.width / 2)
                : countryRect.left + countryRect.width / 2 - dialogWidth / 2;
            const top = hasTooltipPosition ? tooltipRect.top + tooltipRect.height / 2 : countryRect.top + countryRect.height / 2;

            modal.style.setProperty('--locations-map-modal-left', `${clamp(left, modalSpacing, modalRect.width - dialogWidth - modalSpacing)}px`);
            modal.style.setProperty('--locations-map-modal-top', `${clamp(top, dialogHeight + modalSpacing, modalRect.height - modalSpacing)}px`);
        };

        const closeModal = () => {
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            modalContent.innerHTML = '';
            activeCountryGroup.forEach((country) => country.classList.remove('is-hovered'));
            activeCountryGroup = [];
            clearShippingCountryState();
            document.body.classList.remove(modalOpenClass);
        };

        const hideTooltip = () => {
            tooltip.classList.remove('is-visible');
            tooltip.setAttribute('aria-hidden', 'true');
        };

        const openModal = (country, card, countries = [], shippingCountries = []) => {
            modalContent.innerHTML = '';
            modalContent.appendChild(card.cloneNode(true));

            activeCountryGroup.forEach((activeCountry) => activeCountry.classList.remove('is-hovered'));
            clearShippingCountryState();

            activeCountryGroup = countries;
            activeShippingGroup = shippingCountries;

            activeCountryGroup.forEach((activeCountry) => activeCountry.classList.add('is-hovered'));
            setShippingCountryState(activeShippingGroup, true);

            setModalPosition(country);
            hideTooltip();
            document.body.classList.add(modalOpenClass);
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            modal.querySelector('[data-locations-map-close]')?.focus();
        };

        const setTooltipPosition = (country) => {
            const mapRect = map.getBoundingClientRect();
            const countryRect = country.getBoundingClientRect();
            const left = countryRect.left + countryRect.width / 2 - mapRect.left;
            const top = countryRect.top + countryRect.height / 2 - mapRect.top;

            tooltip.style.left = `${left}px`;
            tooltip.style.top = `${top}px`;
        };

        const showTooltip = (country, card) => {
            const flag = card.querySelector('.pages-locations-map__flag');

            tooltipFlag.innerHTML = flag ? flag.innerHTML : '';
            tooltipFlag.classList.toggle('is-wide', flag?.classList.contains('pages-locations-map__flag--wide'));
            tooltipName.textContent = card.dataset.countryName || card.dataset.country || '';
            setTooltipPosition(country);
            tooltip.classList.add('is-visible');
            tooltip.setAttribute('aria-hidden', 'false');
        };

        Object.keys(countryItems).forEach((countryCode) => {
            const countries = getCountryShapes(countryCode);
            const card = countryItems[countryCode];

            if (!countries.length || !card) return;

            const shippingCountryCodes = parseCountryCodes(card.dataset.shippingCountries);
            const shippingCountries = shippingCountryCodes.flatMap((shippingCountryCode) => getCountryShapes(shippingCountryCode));

            const setGroupedCountryState = (isHovered) => {
                countries.forEach((groupedCountry) => {
                    groupedCountry.classList.toggle('is-hovered', isHovered);
                });
            };

            const setCurrentShippingCountryState = (isHovered) => {
                setShippingCountryState(shippingCountries, isHovered);
            };

            countries.forEach((country) => {
                country.classList.add('pages-locations-map__country-shape--active');
                country.setAttribute('tabindex', '0');
                country.setAttribute('role', 'button');
                country.setAttribute('aria-label', card.dataset.countryName || countryCode);

                country.addEventListener('mouseenter', () => {
                    setGroupedCountryState(true);
                    setCurrentShippingCountryState(true);
                    showTooltip(country, card);
                });

                country.addEventListener('focus', () => {
                    setGroupedCountryState(true);
                    setCurrentShippingCountryState(true);
                    showTooltip(country, card);
                });

                country.addEventListener('mouseleave', () => {
                    if (modal.classList.contains('is-open')) return;

                    setGroupedCountryState(false);
                    setCurrentShippingCountryState(false);
                    hideTooltip();
                });

                country.addEventListener('blur', () => {
                    if (modal.classList.contains('is-open')) return;

                    setGroupedCountryState(false);
                    setCurrentShippingCountryState(false);
                    hideTooltip();
                });

                country.addEventListener('click', () => openModal(country, card, countries, shippingCountries));

                country.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        openModal(country, card, countries, shippingCountries);
                    }
                });
            });
        });

        section.querySelectorAll('[data-locations-map-close]').forEach((button) => {
            button.addEventListener('click', closeModal);
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && modal.classList.contains('is-open')) {
                closeModal();
            }
        });
    });
});

// Custom select
document.addEventListener('DOMContentLoaded', () => {
    const selects = document.querySelectorAll('select:not([data-custom-select-ready])');

    if (!selects.length) return;

    const closeAllSelects = (currentSelect = null) => {
        document.querySelectorAll('.custom-select.is-open').forEach((customSelect) => {
            if (customSelect !== currentSelect) {
                customSelect.classList.remove('is-open');
                customSelect.querySelector('.custom-select__button')?.setAttribute('aria-expanded', 'false');
            }
        });
    };

    const setFocusedOption = (options, index) => {
        options.forEach((option, optionIndex) => {
            option.classList.toggle('is-focused', optionIndex === index);
        });

        options[index]?.focus();
    };

    const createCustomSelect = (select) => {
        if (select.dataset.customSelectReady) return;

        const options = Array.from(select.options);
        const wrapper = document.createElement('div');
        const button = document.createElement('button');
        const value = document.createElement('span');
        const icon = document.createElement('span');
        const list = document.createElement('ul');
        const selectId = select.id || select.name || `custom-select-${Math.random().toString(36).slice(2)}`;

        wrapper.className = 'custom-select';
        wrapper.dataset.customSelect = '';
        wrapper.classList.toggle('is-disabled', select.disabled);

        button.className = 'custom-select__button';
        button.type = 'button';
        button.setAttribute('aria-haspopup', 'listbox');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', `${selectId}-list`);
        button.disabled = select.disabled;

        value.className = 'custom-select__value';
        icon.className = 'custom-select__icon';
        icon.setAttribute('aria-hidden', 'true');

        list.className = 'custom-select__list';
        list.id = `${selectId}-list`;
        list.setAttribute('role', 'listbox');

        button.appendChild(value);
        button.appendChild(icon);
        wrapper.appendChild(button);
        wrapper.appendChild(list);

        select.dataset.customSelectReady = 'true';
        select.tabIndex = -1;
        select.setAttribute('aria-hidden', 'true');
        select.parentNode.insertBefore(wrapper, select);
        wrapper.appendChild(select);

        const customOptions = options.map((option, index) => {
            const item = document.createElement('li');
            const optionButton = document.createElement('button');

            optionButton.className = 'custom-select__option';
            optionButton.type = 'button';
            optionButton.textContent = option.textContent;
            optionButton.dataset.value = option.value;
            optionButton.setAttribute('role', 'option');
            optionButton.disabled = option.disabled;

            optionButton.addEventListener('click', () => {
                if (optionButton.disabled) return;

                select.selectedIndex = index;
                select.dispatchEvent(new Event('change', { bubbles: true }));
                close();
                button.focus();
            });

            item.appendChild(optionButton);
            list.appendChild(item);

            return optionButton;
        });

        const sync = () => {
            const selectedOption = select.options[select.selectedIndex] || select.options[0];
            const selectedIndex = Math.max(select.selectedIndex, 0);

            value.textContent = selectedOption?.textContent || '';
            customOptions.forEach((option, index) => {
                const isSelected = index === selectedIndex;

                option.classList.toggle('is-selected', isSelected);
                option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            });
        };

        const open = () => {
            if (select.disabled) return;

            closeAllSelects(wrapper);
            wrapper.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
            setFocusedOption(customOptions, Math.max(select.selectedIndex, 0));
        };

        const close = () => {
            wrapper.classList.remove('is-open');
            button.setAttribute('aria-expanded', 'false');
            customOptions.forEach((option) => option.classList.remove('is-focused'));
        };

        const toggle = () => {
            if (wrapper.classList.contains('is-open')) {
                close();
            } else {
                open();
            }
        };

        button.addEventListener('click', toggle);

        button.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();
                open();
            }
        });

        list.addEventListener('keydown', (event) => {
            const currentIndex = customOptions.findIndex((option) => option === document.activeElement);
            const selectedIndex = currentIndex > -1 ? currentIndex : Math.max(select.selectedIndex, 0);

            if (event.key === 'Escape') {
                event.preventDefault();
                close();
                button.focus();
            }

            if (event.key === 'ArrowDown') {
                event.preventDefault();
                setFocusedOption(customOptions, Math.min(selectedIndex + 1, customOptions.length - 1));
            }

            if (event.key === 'ArrowUp') {
                event.preventDefault();
                setFocusedOption(customOptions, Math.max(selectedIndex - 1, 0));
            }

            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                document.activeElement?.click();
            }
        });

        select.addEventListener('change', sync);

        select.closest('form')?.addEventListener('reset', () => {
            setTimeout(sync, 0);
        });

        sync();
    };

    selects.forEach(createCustomSelect);

    document.addEventListener('click', (event) => {
        if (!event.target.closest('.custom-select')) {
            closeAllSelects();
        }
    });
});

// CF7 files
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.form-file__input').forEach((input) => {
        const section = input.closest('.form-section--file');

        if (!section) {
            return;
        }

        const form = input.closest('.wpcf7-form');
        const fileNames = section.querySelector('.form-file__names');
        const removeLabel = section.dataset.fileRemoveLabel || 'Usuń';
        const removeAria = section.dataset.fileRemoveAria || 'Usuń plik';

        if (!fileNames) {
            return;
        }

        const clearFiles = () => {
            input.value = '';
            fileNames.innerHTML = '';
        };

        const renderFiles = () => {
            fileNames.innerHTML = '';

            if (!input.files.length) {
                return;
            }

            Array.from(input.files).forEach((file) => {
                const item = document.createElement('li');
                item.className = 'form-file__name';

                const name = document.createElement('span');
                name.className = 'form-file__name-text';
                name.textContent = file.name;

                const remove = document.createElement('button');
                remove.className = 'form-file__remove';
                remove.type = 'button';
                remove.setAttribute('aria-label', `${removeAria}: ${file.name}`);
                remove.textContent = removeLabel;

                remove.addEventListener('click', clearFiles);

                item.appendChild(name);
                item.appendChild(remove);
                fileNames.appendChild(item);
            });
        };

        input.addEventListener('change', renderFiles);

        if (form) {
            form.addEventListener('reset', clearFiles);
        }

        document.addEventListener('wpcf7mailsent', function (event) {
            if (form && event.target === form) {
                clearFiles();
            }
        });
    });
});
